// extracted by mini-css-extract-plugin
export default {"dialogAction":"CustomDialog_dialogAction__SLIRP","dialogTitle":"CustomDialog_dialogTitle__ZaX-9","closeButton":"CustomDialog_closeButton__v+U3r"};